var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderShirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.745 2.25C14.745 2.25 13.6772 2.625 12 2.625C10.3228 2.625 9.255 2.25 9.255 2.25C9.08627 2.25006 8.91877 2.27858 8.75953 2.33437L1.5 4.875L2.27953 9L4.57078 9.25875C4.85137 9.2905 5.10976 9.42662 5.29464 9.64007C5.47952 9.85352 5.57737 10.1287 5.56875 10.4109L5.25 21.75H18.75L18.4313 10.4109C18.4226 10.1287 18.5205 9.85352 18.7054 9.64007C18.8902 9.42662 19.1486 9.2905 19.4292 9.25875L21.7205 9L22.5 4.875L15.2405 2.33437C15.0812 2.27858 14.9137 2.25006 14.745 2.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6238 2.46851C15.4112 3.26733 14.9407 3.97354 14.2853 4.47733C13.63 4.98112 12.8265 5.25424 11.9999 5.25424C11.1733 5.25424 10.3698 4.98112 9.71444 4.47733C9.05907 3.97354 8.58853 3.26733 8.37598 2.46851",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderShirt);
export default __webpack_public_path__ + "static/media/header-shirt.abdff1ed7c72808595d4fcc89dd5b757.svg";
export { ForwardRef as ReactComponent };